import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BackendIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M428.522,55.652H408.75c-6.915-19.391-25.274-33.391-47.01-33.391H150.261c-21.737,0-40.095,14-47.01,33.391H83.478 C37.446,55.652,0,93.098,0,139.13v133.565c0,27.619,22.468,50.087,50.087,50.087h16.696v116.87 c0,27.619,22.468,50.087,50.087,50.087H395.13c27.619,0,50.087-22.468,50.087-50.087v-116.87h16.696 c27.619,0,50.087-22.468,50.087-50.087V139.13C512,93.098,474.554,55.652,428.522,55.652z M311.652,306.087 c0,9.206-7.49,16.696-16.696,16.696h-77.913c-9.206,0-16.696-7.49-16.696-16.696v-16.696h111.304V306.087z M411.826,256 c-127.433,0-158.32,0-311.652,0v-50.087c0-9.206,7.49-16.696,16.696-16.696H395.13c9.206,0,16.696,7.49,16.696,16.696V256z M478.609,272.696c0,9.206-7.49,16.696-16.696,16.696h-16.696v-83.478c0-27.619-22.468-50.087-50.087-50.087H116.87 c-27.619,0-50.087,22.468-50.087,50.087v83.478H50.087c-9.206,0-16.696-7.49-16.696-16.696V139.13 c0-27.619,22.468-50.087,50.087-50.087h19.772c6.915,19.391,25.275,33.391,47.01,33.391h211.478c21.737,0,40.095-14,47.01-33.391 h19.772c27.619,0,50.087,22.468,50.087,50.087V272.696z" />
  </svg>
)
const ForwardRef = forwardRef(BackendIcon)
export { ForwardRef as ReactComponent }
